module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/_babel-runtime@6.26.0@babel-runtime/core-js/array/from.js
// module id = 357
// module chunks = 0